import {
    BaseEdge,
    EdgeLabelRenderer,
    getSmoothStepPath,
    useReactFlow,
} from '@xyflow/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons'

export default function CustomEdge({
    id,
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    centerX,
    borderRadius,
    centerY,
    offset,
    data,
}) {
    const { setEdges } = useReactFlow()
    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        centerX,
        borderRadius,
        centerY,
        offset,
    })

    const { name } = data

    return (
        <>
            <BaseEdge id={id} path={edgePath} />
            <EdgeLabelRenderer>
                <button
                    style={{
                        position: 'absolute',
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                        pointerEvents: 'all',
                    }}
                    className="nodrag nopan edge-custom"
                    onClick={() => {
                        setEdges((es) => es.filter((e) => e.id !== id))
                    }}
                >
                    ارتباط &nbsp;
                    {name}
                    <FontAwesomeIcon icon={faCircleXmark} />
                </button>
            </EdgeLabelRenderer>
        </>
    )
}
